<template>
  <div>
    <table-list
      :title="tableTitle"
      :loading="loading"
      :btns="btns(this)"
      :search-form="searchForm(this)"
      :data="orderList"
      :options="{ selection: true }"
      :columns="columns(this)"
      :operates="operates(this)"
      :pager="pager"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
  </div>
</template>

<script>
//表格标题
const tableTitle = '订单列表'
const btns = _this => [
  {
    label: '导出',
    type: 'primary',
    method: _this.handleExport,
  },
]
// 搜索框配置
const searchForm = _this => [
  {
    label: '订单编号',
    prop: 'orderId',
  },
  {
    label: '订单内容',
    prop: 'productName',
  },
  {
    label: '支付方式',
    prop: 'payType',
    type: 'select',
    children: _this.payType.map(item => ({ value: item.key, label: item.value })),
  },
  {
    label: '支付状态',
    prop: 'payStatus',
    type: 'select',
    defaultValue: _this.waitOrderPay,
    children: _this.payStatus.map(item => ({ value: item.key, label: item.value })),
  },
  {
    label: '支付时间',
    prop: 'time',
    type: 'picker',
  },
]
// 表格列配置
const columns = () => [
  {
    prop: 'orderId',
    label: '订单编号',
  },
  {
    prop: 'productName',
    label: '订单内容',
  },
  {
    label: '实付金额',
    render: (h, { row }) => {
      return h('div', row.amount ? '￥' + row.amount : '')
    },
  },
  {
    label: '原价',
    render: (h, { row }) => {
      return h('div', row.originalPrice ? '￥' + row.originalPrice : null)
    },
  },
  {
    prop: 'payTypeName',
    label: '支付渠道',
  },
  {
    prop: 'createTimeShow',
    label: '创建时间',
  },
  {
    label: '支付时间',
    prop: 'payTimeShow',
  },
  {
    prop: 'orderStatusName',
    label: '状态',
  },
]
// 表格操作按钮配置
const operates = _this => [
  {
    label: '详情',
    method: _this.handleDetail,
  },
]
const payType = [
  { key: 'WXPAY', value: '微信' },
]
const payStatus = [
  { key: 'SUCCESS', value: '已支付' },
  { key: 'WAIT', value: '未支付' },
  { key: 'REFUND', value: '已退款' },
  { key: 'CLOSE', value: '已取消' },
]
import to from 'await-to'
import { getOrderList, orderListExport } from '@/api/finance'
import TableList from '@/components/TableList'
export default {
  components: {
    TableList,
  },
  data() {
    return {
      btns,
      tableTitle,
      searchForm,
      columns,
      operates,
      payType,
      payStatus,
      loading: false,
      pager: {
        total: 0,
        size: 10,
        current: 1,
        payStatus: '',
        payType: '',
        orderId: '',
        productName: '',
        beginPayTime: '',
        endPayTime: '',
      },
      orderList: [],
      waitOrderPay: this.$route.query.waitOrderPay || '',
      select: [],
    }
  },
  created() {
    if (this.waitOrderPay !== '') {
      this.pager.payStatus = this.waitOrderPay
    }
    this.getOrderListData()
  },
  methods: {
    async getOrderListData() {
      this.loading = true
      const [res, err] = await to(getOrderList({ ...this.pager }))
      if (err) return this.$message({ type: 'error', message: err.msg })
      this.loading = false
      this.orderList = res.data.list
      this.pager.total = res.data.total
    },
    onSearch(params) {
      this.pager.orderId = params.orderId
      this.pager.productName = params.productName
      this.pager.payType = params.payType
      this.pager.payStatus = params.payStatus
      if (params.time && params.time.length !== 0) {
        this.pager.beginPayTime = params.time[0]
        this.pager.endPayTime = params.time[1]
      } else {
        this.pager.beginPayTime = ''
        this.pager.endPayTime = ''
      }
      this.pager.current = 1
      this.getOrderListData()
    },
    handleDetail(row) {
      this.$router.push({ path: '/finance/detail', query: { id: row.orderId } })
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getOrderListData()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getOrderListData()
    },
    handleSelectionChange(val) {
      this.select = val
    },
    async handleExport() {
      let orderIds = []
      this.select.map(v => orderIds.push(v.orderId))
      const [res, err] = await to(orderListExport({ ...this.pager, orderIds }))
      if (err) return this.$message.warning(err.msg)
      let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = '订单列表.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
  },
}
</script>

<style scoped></style>
